import DeveloperResource from '@/resources/DeveloperResource';

export default class Developer {
    constructor() {
        this.Resource = new DeveloperResource()
    }

    async get () {
        const developer = await this.Resource.get()
        return developer.data.me.developer
    }

    async update () {
        const developer = await this.Resource.update()
        return developer.data.updateDeveloper
    }

    async delete () {
        const developer = await this.Resource.delete()
        return developer.data.deleteDeveloper
    }
}